<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('email_templates')"
                        :isNewButton="checkPermission('emailtemplate_store')"
                        @new-button-click="createFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('email_templates')"
                              :isNewButton="checkPermission('emailtemplate_store')"
                              @new-button-click="createFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear"  :exportExcel="checkPermission('emailtemplate_excelexport')"
                              @exportExcel="exportExcel">
                <b-row>
                    <b-col sm="6">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('code')">
                            <b-form-input v-model="datatable.queryParams.filter.code_like">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('subject')">
                            <b-form-input v-model="datatable.queryParams.filter.subject">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group :label="$t('units')">
                            <units-selectbox v-model="datatable.queryParams.filter.unit_id" :multiple="true"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                       :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                       @on-page-change="onPageChange" @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('district_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('district_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpperCase() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from "@/layouts/AppLayout";
    import Header from "@/layouts/AppLayout/Header"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    //Component
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import Datatable from "@/components/datatable/Datatable";
    import CommonModal from "@/components/elements/CommonModal";
    import UnitsSelectbox from "@/components/interactive-fields/UnitsSelectbox.vue";
    //Other
    import qs from "qs";
    //Service
    //Page
    import CreateForm from "./CreateForm";
    import UpdateForm from "./UpdateForm";
    import EmailTemplateServices from "@/services/EmailTemplateServices";

    export default {
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            CreateForm,
            UpdateForm,
            DatatableFilter,
            Datatable,
            CommonModal,
            UnitsSelectbox,
        },
        metaInfo() {
            return {
                title: this.$t("email_templates"),
            };
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: "",
                            field: "buttons",
                            html: true,
                            sortable: false,
                            tdClass: "p-0 text-center w-40 align-middle",
                            buttons: [
                                {
                                    text: this.$t("edit"),
                                    class: "ri-edit-box-line",
                                    permission: 'district_update',
                                    callback: (row) => {
                                        this.updateForm(row.id);
                                    },
                                },
                                {
                                    text: this.$t("delete"),
                                    class: "ri-delete-bin-2-line",
                                    permission: 'district_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    },
                                },
                            ],
                        },
                        {
                            label: this.$t("code"),
                            field: "code",
                            sortable: true,
                        },
                        {
                            label: this.$t("name"),
                            field: "name",
                            sortable: false,
                        },
                        {
                            label: this.$t("units"),
                            field: "units",
                            sortable: false,
                            formatFn: (value) => value?.map(item => item.name).join(", ") || "-",
                        },
                        {
                            label: this.$t("subject"),
                            field: "subject",
                            sortable: false,
                        },
                        {
                            label: this.$t("recipients"),
                            field: "recipients",
                            sortable: false,
                        }

                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: "id",
                        page: 1,
                        limit: 20,
                    },
                },
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == "desc" ? "-" : "";
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getCleanQueryParams() {
                const queryParams = JSON.parse(JSON.stringify(this.datatable.queryParams));
                if (queryParams.filter) {
                    Object.keys(queryParams.filter).forEach((key) => {
                        const val = queryParams.filter[key];
                        if (val === null || val === undefined || val === '' || (Array.isArray(val) && val.length === 0)) {
                            delete queryParams.filter[key];
                        }
                    });
                }
                return queryParams;
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;
                const config = {
                    params: this.getCleanQueryParams(),
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };
                return EmailTemplateServices.getAll(config)
                                             .then((response) => {
                                                 this.datatable.rows = response.data.data;
                                                 this.datatable.total = response.data.pagination.total;
                                             })
                                             .finally(() => {
                                                 this.datatable.isLoading = false;
                                             });
            },

            delete(id) {
                this.deleteModal(() => {
                    EmailTemplateServices.del(id)
                                          .then((response) => {
                                              this.filter();
                                              this.$toast.success(this.$t("api." + response.data.message));
                                          })
                                          .catch((error) => {
                                              this.$toast.error(this.$t("api." + error.data.message));
                                          });
                });
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
            updateForm(id) {
                this.formId = id
                this.formProcess = 'update'
                this.$refs.updateFormModal.$refs.commonModal.show()
            },
            exportExcel(){
                const config = {
                    params: this.getCleanQueryParams(),
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return EmailTemplateServices.exportExcel(config)
                    .then((response) => {
                        this._downloadFile(response,this.$t('email-templates')+'.xlsx')
                    })
                    .catch(err=>this.showErrors(err))
            },
        },
    };
</script>

